import { render, staticRenderFns } from "./service-settings.vue?vue&type=template&id=3342690b&scoped=true"
import script from "./service-settings.vue?vue&type=script&lang=ts"
export * from "./service-settings.vue?vue&type=script&lang=ts"
import style0 from "./service-settings.vue?vue&type=style&index=0&id=3342690b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342690b",
  null
  
)

export default component.exports